import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useRouteError } from 'react-router-dom';
import { CheckingValidComment, getCookie, getProjectId } from '../lib/common';
import styles from '../styles/Accordion.module.scss';
import { sendTicketsApi } from '../api';
import { useLocalStorage } from '../hooks';

export default function ReportErrorPage({ errorLog }) {
  const error = useRouteError();
  const navigate = useNavigate();
  const [isReportError, setIsReportError] = useState(false);
  const [errorDescrption, setErrorDescrption] = useState('');
  const enableSubmitButton = CheckingValidComment(errorDescrption);
  const projectId = getProjectId();
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const sid = getCookie('sid');
  document.body.style.overflow = 'unset';

  const handleBackButton = () => {
    if (projectId === 'csportal') {
      navigate('/csportal');
    } else {
      navigate('/genio');
    }
    window.location.reload();
  };
  return (
    <div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          background: '#1276d7',
          color: 'white',
          height: '9vh',
          marginBottom: '68px',
          alignItems: 'center',
        }}
      >
        <div
          aria-label="header_back_btn"
          tabIndex={0}
          role="button"
          onKeyDown={() => {}}
          className={`csicon ${styles.page_whiteback_icon} `}
          style={{ height: '24px', width: '24px', marginLeft: '11px' }}
          id="headerback"
          onClick={() => handleBackButton()}
        />
        <span style={{ textAlign: 'center', width: '100%', fontWeight: 600, marginRight: '10px', fontSize: '14px' }}>
          Customer Support
        </span>
      </div>

      <section className="cspage cslanding mt-40">
        <div className="thankyouwrp text_center p-20">
          <span className="congratulationicn" />
          <div className="thanktxt pb-15">Oops! Something Went wrong</div>
          <div className="font14 fw400 color777">
            <button
              type="button"
              className="bluefill_animate font12 fw600 colorFFF"
              style={{ padding: '6px' }}
              onClick={() => setIsReportError(true)}
            >
              Report This Error
            </button>
          </div>
          {isReportError && (
            <>
              <div className="csexpndwp_content" style={{ marginTop: '15px' }}>
                <>
                  <textarea
                    className={`${styles.Accordion__TextArea}`}
                    value={errorDescrption}
                    placeholder="Please describe your issue here, our team will get back to you within 24-48 hours"
                    onChange={(e) => {
                      setErrorDescrption(e.target.value);
                    }}
                  />
                  <button
                    type="button"
                    className={`${
                      enableSubmitButton ? 'bluefill_animate colorFFF' : 'diablebtnErrorPage'
                    } font12 fw600`}
                    disabled={!enableSubmitButton}
                    onClick={async () => {
                      let description = `errorDescrption-${projectId}-${projectId === 'csportal' ? selectedBusiness?.docid || '' : selectedBusinessGenio?.docId || ''}`;
                      if (sid) {
                        description += `-${sid}`;
                      }
                      const res = await sendTicketsApi({
                        description,
                        error:
                          (error?.stack && JSON.stringify(error?.stack)) ||
                          error?.message ||
                          errorLog ||
                          'Error occured',
                      });
                      if (res) {
                        if (projectId === 'csportal') {
                          navigate('/csportal');
                        } else {
                          navigate('/genio');
                        }
                        window.location.reload();
                      }
                    }}
                  >
                    Submit
                  </button>
                  <br />
                  {!enableSubmitButton && errorDescrption && errorDescrption.length > 3 && (
                    <span className="colorEC4 font12 fw500 ml-5">Please avoid special characters...</span>
                  )}
                </>
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
}

ReportErrorPage.propTypes = {
  errorLog: PropTypes.any,
};
